type QuoteSendStatusSource = {
  quoteStatus?: string;
};

type QuoteSendButtonStateParams = {
  selectedSystems: Array<QuoteSendStatusSource & { uniqueId: string }>;
  selectedDuctedSystems: Array<QuoteSendStatusSource & { id: number | string }>;
  quoteIDsToSend: string[];
};

export type QuoteSendButtonState = {
  text: string;
  disabled: boolean;
  isSending: boolean;
};

const sendSelectedQuoteLabel = (count: number): string =>
  count === 1 ? 'Send Selected Quote' : 'Send Selected Quotes';

export function getQuoteSendButtonState({
  selectedSystems,
  selectedDuctedSystems,
  quoteIDsToSend
}: QuoteSendButtonStateParams): QuoteSendButtonState {
  const selected = [
    ...selectedSystems.filter((system) =>
      quoteIDsToSend.includes(system.uniqueId)
    ),
    ...selectedDuctedSystems.filter((system) =>
      quoteIDsToSend.includes(system.id.toString())
    )
  ];

  if (quoteIDsToSend.length < 1) {
    return {
      text: 'Select a quote to send',
      disabled: true,
      isSending: false
    };
  }

  const isSending = selected.some((system) => system.quoteStatus === 'sending');
  if (isSending) {
    return {
      text: 'Sending quote...',
      disabled: true,
      isSending: true
    };
  }

  if (
    selected.length > 0 &&
    selected.every((system) => system.quoteStatus === 'sent')
  ) {
    return {
      text: 'Quote sent',
      disabled: true,
      isSending: false
    };
  }

  return {
    text: sendSelectedQuoteLabel(quoteIDsToSend.length),
    disabled: !selected.some((system) => system.quoteStatus === 'unsent'),
    isSending: false
  };
}
